/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Security_Monitoring_LabelInputs */

const es_privacy_policy_security_monitoring_label = /** @type {(inputs: Privacy_Policy_Security_Monitoring_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoreo y Auditorias`)
};

const en_privacy_policy_security_monitoring_label = /** @type {(inputs: Privacy_Policy_Security_Monitoring_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoring and Audits`)
};

/**
* | output |
* | --- |
* | "Monitoring and Audits" |
*
* @param {Privacy_Policy_Security_Monitoring_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_security_monitoring_label = /** @type {((inputs?: Privacy_Policy_Security_Monitoring_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Security_Monitoring_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_security_monitoring_label(inputs)
	return en_privacy_policy_security_monitoring_label(inputs)
});
export { privacy_policy_security_monitoring_label as "privacy_policy.security.monitoring_label" }